import { Pipe, PipeTransform } from '@angular/core';
import { User } from '../../classes/user';

@Pipe({
  name: 'activeFilter',
  pure: false
})
export class ActiveFilterPipe implements PipeTransform {

  transform(userList: Array<User>, filterValue: string): any {
    if (!userList || !filterValue) {
      return userList;
    }
    return userList.filter(user => {
      const userActiveString = user.active ? 'sì' : 'no';
      return userActiveString.indexOf(filterValue.toLowerCase()) !== -1;
    });
  }

}
